import { useQuery, useMutation } from "@tanstack/react-query";
import apis from "#store/api";
import { Tenant } from "./tenants";
import { DataCollectionApiResponse } from "./types";

interface ResetPasswordParams {
  email: string;
  token: string;
  newPassword: string;
}

interface RequestResetPasswordParams {
  email: string;
}

interface GetUserTenantsParams {
  email: string;
}

interface UseUserTenantsOptions {
  enabled?: boolean;
}

export const useRequestResetPassword = () => {
  return useMutation({
      mutationFn: async (params: RequestResetPasswordParams) => {
          const response = await apis.auth.requestResetPassword({ data: params });
          return response.data;
      }
  });
};

export const useResetPassword = () => {
  return useMutation({
      mutationFn: async (params: ResetPasswordParams) => {
          const response = await apis.auth.resetPassword({ data: params });
          return response.data;
      }
  });
};

export const useOrganizationRequest = (params: GetUserTenantsParams, options: UseUserTenantsOptions = {}) => {
  return useQuery({
    queryKey: ["organizationRequest", params],
    queryFn: async () => {
      const response = await apis.auth.organizationRequest({ params });
      return response.data as DataCollectionApiResponse<Tenant>;
    },
    enabled: options.enabled,
    retry: false,
    staleTime: 0
  });
};